
const featureFlags = {
    home: {
        showTrustedCustomers: true,
        showTestimonials: false,
    },
    contactUs: {
        showSocialMediaLinks: false,
    },
    legal: {
        showDemoLink: false,
        showWhatYouCanAccomplish: false,
    },

}

export default featureFlags;